<template>
  <v-card
    class="d-flex flex-column flex-nowrap"
    :class="[hasEqHeight ? 'eq-height' : '', hasEqWidth ? 'eq-width' : '']"
    :color="color"
    :dark="isDark"
  >
    <div
      v-if="chip"
      class="d-flex justify-space-between mx-3 mt-3"
    >
      <v-chip
        label
        color="grey lighten-2"
      >
        <span class="texte texte-gris-fonce">{{ chip.libelle }}</span>
      </v-chip>
      <div class="align-self-center ml-3">
        <v-icon
          v-if="hasHelp"
          @click="onHelp"
        >
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <div class="d-flex flex-nowrap justify-space-between mx-3 mt-3">
      <div class="d-flex">
        <div
          class="font-weight-bold"
          :class="[$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3', isDark ? 'white--text' : 'secondary--text ']"
        >
          {{ titreFormatted }}
        </div>
        <v-chip
          v-if="titreInfoWarning && !loading"
          small
          color="accent"
          class="ml-5"
        >
          {{ titreInfoWarning }}
        </v-chip>
        <AgrButton
          v-if="objectIsButtonAvailable && !loading"
          small
          class="ml-3"
          :disabled="objectIsButtonAvailable.disabled"
          @click="clickButton()"
        >
          <v-icon
            v-if="objectIsButtonAvailable.icon"
            class="mr-1"
            small
          >
            {{ objectIsButtonAvailable.icon }}
          </v-icon>
          {{ objectIsButtonAvailable.libelle }}
        </AgrButton>
      </div>
      <div
        v-if="!chip"
        class="align-self-center ml-3"
      >
        <v-icon
          v-if="hasHelp"
          @click="onHelp"
        >
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <div>
      <slot v-if="!loading" />
      <BaseLoader v-else />
    </div>
    <v-row no-gutters>
      <v-col
        v-if="btnActionSecondaire"
        cols="12"
        md="6"
        class="mt-auto pt-3 mb-2 mb-md-5 px-3"
      >
        <AgrButton
          elevation="0"
          block
          outlined
          large
          @click="onDetail(btnActionSecondaire)"
        >
          <span class="action text-truncate --text-branche">{{
            btnActionSecondaire.libelle
          }}</span>
        </AgrButton>
      </v-col>
      <v-col
        v-if="btnAction"
        cols="12"
        :md="btnActionSecondaire ? 6 : 12"
        class="mt-auto pt-3 mb-5 px-3"
      >
        <v-badge
          v-if="btnVBadge > 0"
          color="red"
          offset-x="30"
          offset-y="10"
          text-color="white"
          :content="btnVBadge"
          class="full-width"
        >
          <AgrButton
            elevation="0"
            block
            large
            @click="onDetail(btnAction)"
          >
            <span class="action text-truncate white--text">
              {{
                btnAction.libelle
              }}</span>
          </AgrButton>
        </v-badge>
        <AgrButton
          v-else
          elevation="0"
          block
          large
          :outlined="btnAction.isOutlined"
          @click="onDetail(btnAction)"
        >
          <v-icon
            v-if="btnAction.icon"
            size="20"
            :color="btnAction.isOutlined ? 'branche' : 'secondary'"
            class="mr-3"
          >
            {{ btnAction.icon }}
          </v-icon>
          <span
            class="action text-truncate"
            :class="btnAction.isOutlined ? '--text-branche' : 'white--text'"
          >{{
            btnAction.libelle
          }}</span>
        </AgrButton>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import capitalize from '@/filters/string.filter'

export default {
  name: 'BaseCardV2',
  components: { AgrButton, BaseLoader },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    titre: {
      type: String,
      default: null
    },
    titreInfoWarning: {
      type: String,
      default: ''
    },
    hasHelp: {
      type: Boolean,
      default: false
    },
    hasEqHeight: {
      type: Boolean,
      default: true
    },
    hasEqWidth: {
      type: Boolean,
      default: true
    },
    btnAction: {
      type: Object,
      default: null
    },
    btnActionSecondaire: {
      type: Object,
      default: null
    },
    color: {
      type: String,
      default: ''
    },
    isDark: {
      type: Boolean,
      default: false
    },
    objectIsButtonAvailable: {
      type: Object,
      default: null
    },
    btnVBadge: {
      type: Number,
      default: 0
    },
    chip: {
      type: Object,
      default: null
    }
  },
  computed: {
    titreFormatted () {
      return this.titre ? capitalize.capitalize(this.titre) : null
    }
  },
  methods: {
    onDetail (btn) {
      if (btn.hasOtherAtion) {
        this.$emit('otherAction')
        return
      }

      this.$emit('avant-navigation', btn)
      this.$router.push(btn.to)
    },
    onHelp () {
      this.$emit('on-help')
    },
    clickButton () {
      this.$emit('button')
    }
  }
}
</script>
<style scoped>
.full-width{
  width:100% !important;
}
</style>


